import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from 'shared/button';
import Errors from 'components/form/errors';
import Input from './input';
import Modal from 'components/modal';

export default function CommentModal({ comment, show, updateComment, onHide }) {
  const [body, setBody] = useState(comment?.body || '');
  const [saving, setSaving] = useState();
  const [errors, setErrors] = useState();

  async function handleSave() {
    setSaving(true);
    const updatedComment = { ...comment, body };
    try {
      await updateComment(updatedComment);
      onHide();
    } catch (errors) {
      setErrors(errors);
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal className="deal-comment-modal visible-overflow" show={show} onHide={onHide}>
      <Modal.Header closeButton>
        Edit Message
      </Modal.Header>

      <Modal.Body>
        <Errors description={false} errors={errors} />
        <div className="form form-horizontal">
          <Input comment={comment} onChange={setBody} />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button.Cancel name="cancel" onClick={onHide} />
        <Button.Primary disabled={saving} name="save" onClick={handleSave}>
          Save
        </Button.Primary>
      </Modal.Footer>
    </Modal>
  );
}

CommentModal.propTypes = {
  comment: PropTypes.shape({
    body: PropTypes.string,
  }),
  show: PropTypes.bool,
  updateComment: PropTypes.func,
  onHide: PropTypes.func.isRequired
};
